import api from './api'

/**
 * Video API service for tutorial videos
 * Handles all video-related API calls
 */
export const videoApi = {
  // ==================
  // Categories
  // ==================

  /**
   * Get all video categories
   * @returns {Promise} List of categories
   */
  getCategories: () => api.get('/video-categories/'),

  /**
   * Get a single category by ID
   * @param {number} id - Category ID
   * @returns {Promise} Category details
   */
  getCategory: (id) => api.get(`/video-categories/${id}/`),

  // ==================
  // Videos
  // ==================

  /**
   * Get all videos with optional filtering
   * @param {Object} params - Query parameters (category, difficulty, search)
   * @returns {Promise} List of videos
   */
  getVideos: (params = {}) => api.get('/tutorial-videos/', { params }),

  /**
   * Get a single video by ID (increments view count)
   * @param {number} id - Video ID
   * @returns {Promise} Video details
   */
  getVideo: (id) => api.get(`/tutorial-videos/${id}/`),

  /**
   * Get popular videos (most viewed)
   * @returns {Promise} List of popular videos
   */
  getPopularVideos: () => api.get('/tutorial-videos/popular/'),

  /**
   * Get recent videos (latest added)
   * @returns {Promise} List of recent videos
   */
  getRecentVideos: () => api.get('/tutorial-videos/recent/'),

  // ==================
  // Progress (requires authentication)
  // ==================

  /**
   * Get user's video progress
   * @returns {Promise} List of video progress
   */
  getProgress: () => api.get('/video-progress/'),

  /**
   * Mark a video as watched
   * @param {number} videoId - Video ID
   * @returns {Promise} Updated progress
   */
  markWatched: (videoId) => api.post('/video-progress/mark_watched/', {
    video_id: videoId
  }),

  /**
   * Update video playback position
   * @param {number} videoId - Video ID
   * @param {number} position - Position in seconds
   * @returns {Promise} Updated progress
   */
  updatePosition: (videoId, position) => api.post('/video-progress/update_position/', {
    video_id: videoId,
    position: position
  }),

  /**
   * Create or update video progress
   * @param {Object} data - Progress data (video, watched, last_position)
   * @returns {Promise} Created/updated progress
   */
  createProgress: (data) => api.post('/video-progress/', data)
}

export default videoApi
